import Cookies from "js-cookie";

import { ENV, MAIN_DOMAIN } from "config";
import { EENV } from "constants/index";

export const deleteCookies = (key: string) => {
  const { hostname } = new URL(MAIN_DOMAIN);
  Cookies.remove(key, {
    domain: ENV === EENV.DEV ? undefined : `.${hostname}`,
  });
};
